/* components/UrlMask.jsx — keeps the address bar short (lib/urlMask.js).
 *
 * Every history write is masked AT THE SOURCE (lib/urlMask.js installHistoryMask,
 * installed at import below): pushState/replaceState receive the display path and
 * the real URL rides in the entry's state (lhcReal) — the bar never holds the real
 * URL, not even for a frame. React Router reads the real path through
 * routerWindowFor() (App.js gives <BrowserRouter window={…}> that proxy), so
 * routing, links and params keep working. <UrlMask /> sits inside the Router
 * above <Routes> only to make sure the mask is installed.
 *
 * <Unmask fallback children> is the route element for a display path (the
 * browser lands on it after a reload or back/forward): it restores the real
 * URL from the entry's state, else renders `children` / redirects to fallback. */
import React, { useLayoutEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { realFromState, installHistoryMask } from "@/lib/urlMask";

/* every history write is masked at the source (React Router’s and the studio’s alike) */
installHistoryMask();

export default function UrlMask() {
  useLayoutEffect(() => { installHistoryMask(); }, []);
  return null;
}

export function Unmask({ fallback = "/", children = null }) {
  const location = useLocation();
  let real = null;
  try { real = realFromState(window.history.state, location.pathname); } catch (_) { real = null; }
  if (real) return <Navigate to={real} replace />;
  if (children) return children;
  return <Navigate to={fallback} replace />;
}
